<template>
  <el-dialog v-bind='$attrs' v-on='$listeners' @open='onOpen'
             width='60%'>
    <template slot="title">
      选择折扣信息 <i class="el-icon-refresh" @click="getTableData" style="color: #ff3176;cursor: pointer;" title="刷新列表"></i>
    </template>
    <div
        v-loading="loading"
        element-loading-text="玩命加载中……"
        element-loading-spinner="el-icon-loading">
      <el-button @click="handleAdd()" class="d-flex-row funcbars-button"
                 v-show="userAuth.rebate_config_info"   size="mini" style="margin-right: 10px;float: right">
        {{ userAuth.rebate_config_save ? '设置' : '查看'}}折扣选项
      </el-button>

      <div class="default-table">
        <el-table
            :data="tableData"
            style="width: 100%"
            height="360"
            highlight-current-row
            @row-click="selectRow"
            header-row-class-name="tbl-header">
          <el-table-column
              width="80"
              label="序号">
            <template slot-scope="scope">
              <span>{{ offset + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
              label="折扣"
              prop="rebate"
              header-align="center"
              align="left"
              min-width="100"
          >
            <template slot-scope="{row}">
              <el-link type="primary" icon="el-icon-thumb" style="text-align: center;display: block;margin: 0 auto">{{ row.rebate }}</el-link>
            </template>
          </el-table-column>
          <el-table-column
              label="规则说明"
              prop="rule_explain"
              align="center"
              min-width="300"
          >
            <template slot-scope="{row}">
              <span>{{ row.rule_explain || '-' }}</span>
            </template>
          </el-table-column>

        </el-table>
        <Pagination
            v-show="total>0"
            :total="total"
            :page.sync="searchCondition.page"
            :limit.sync="searchCondition.per_page"
            @pagination="getTableData"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>

import {getDiscountsList} from "@/api/discount";

export default {
  name: "DiscountSelect",
  data() {
    return {
      loading: true,
      offset: 0,
      total: 0,
      searchCondition: {
        page: 1, per_page: 10
      },
      tableData: [],
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  methods: {
    onOpen() {
      this.getTableData()
    },
    handleAdd() {
      const {href} = this.$router.resolve({
        name: 'orderDiscount',
      });
      window.open(href, "_blank");
    },
    // ------ 分页相关 ---------
    getPagingInfo() {
      return {
        per_page: this.searchCondition.per_page,
        page: this.searchCondition.page
      }
    },
    async getTableData() {
      this.loading = true
      let pagingInfo = this.getPagingInfo()

      const response = await getDiscountsList(pagingInfo)
      this.tableData = response.model.data || []
      let pageData = response.model
      this.tableData = pageData.data
      this.searchCondition.per_page = pageData.per_page
      this.total = pageData.total
      this.offset = (pageData.current_page - 1) * pageData.per_page
      this.loading = false
    },
    selectRow(row, column) {
      // e.preventDefault();//阻止元素发生默认的行为
      // e.preventDefault();//阻止元素发生默认的行为
      if (column.property === 'rebate') {
        this.$emit('selectRow', row)
      }
    },

  }
}
</script>
